import React from 'react'
import StudentBody from '../../../components/AdminDashboard/Students/StudentBody'
import SideNav from '../../../layouts/AdminDashboard/SideNav'

const BootcampStudent = () => {
    return (
        <div className='flex justify-end mobile:justify-start mobile:w-screen mobile:flex-col min-h-screen w-full mobile:bg-[#E5E5E5]'>

            {/* Side nav */}
            <SideNav />

            {/* Body section */}
            <StudentBody />
        </div>
    )
}

export default BootcampStudent